<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/productos']">Inicio</a>
            </li>
            <li class="nav-item active">
                <a class="nav-link" [routerLink]="['/administracion']">Pedidos<span class="badge badge-danger">{{cont}}</span> <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/solicitudes']">Solicitudes<span class="badge badge-success">{{solicitudes}}</span></a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/GestionProductos']">Productos</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/clientes']">Clientes</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" (click)="onLogout()">Cerrar Sesión</a>
            </li>
        </ul>
    </div>
</nav>